module.exports = __webpack_public_path__ + "static/media/logo2.ca4f0d62.png";